import React, { useState } from "react";
import { Link, useLocation, useNavigate } from "react-router-dom";
// import { FaShoppingCart } from "react-icons/fa";
import { MdEdit } from "react-icons/md";
import { IoHeart } from "react-icons/io5";
import { IoIosSettings } from "react-icons/io";
import { useUser } from "../../context/UserContext";
import defaultUser from "../../assets/images/defaultUserProfilePicture.jpg";
import { IoHome } from "react-icons/io5";
import { BiLogOutCircle } from "react-icons/bi";
import { VscHistory } from "react-icons/vsc";
import { PiMedalFill } from "react-icons/pi";
import { toast } from "react-toastify";
import { useLanguage } from "../../context/LanguageContext";

const Sidebar: React.FC<{ className?: string }> = ({ className }) => {
  const { t } = useLanguage();
  const { user } = useUser();
  const location = useLocation();
  const activeLink = "text-[#FFC633] font-extrabold";
  const navigate = useNavigate();
  const [logoutModal, setLogoutModal] = useState(false);

  const handleClickLogout = () => {
    setLogoutModal(true);
  };

  const logOutConfirm = () => {
    localStorage.removeItem("user");
    localStorage.removeItem('favoriteProductIds');
    localStorage.removeItem('access-token');
    localStorage.removeItem('basketItems');
    toast.success(t('toastMessage', 'logout'));
    setTimeout(() => {
      navigate("/");
      window.location.reload();
    }, 2000);
  };

  return (
    <div className={`border-r  p-4 bg-[#141C3A]  ${className}`}>
      <div className="flex items-center mb-4 gap-7 cursor-pointer justify-start pl-0 md:pl-4">
        <img
          className=" w-14 h-14 rounded-full object-cover min-w-14 min-h-14"
          src={user?.profilePicture ? user?.profilePicture : defaultUser}
          alt="user_image"
        />
        <div className=" flex  items-center gap-x-2 ">
          <IoHome
            onClick={() => navigate("/")}
            className=" text-[#FAD983] text-2xl]"
          />
          <Link
            to={"/"}
            className=" text-[#FAD983] mt-[2px] hidden md:block font-rubik text-[18px]"
          >
            {t('sideBar', 'home')}
          </Link>
        </div>
      </div>

      <ul className="space-y-8 md:space-y-0 pt-4 text-[#FAD983] font-semibold font-rubik text-[18px] ">
        <li>
          <Link
            to="/"
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start`}
          >
            <IoHome className=" text-2xl block md:hidden" />
          </Link>
        </li>

        <li>
          <Link
            to="/profile/edit"
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
              location.pathname === "/profile/edit" ? activeLink : ""
            }`}
          >
            <MdEdit className=" text-2xl " />
            <span className="hidden md:block ml-2">{t('sideBar', 'edit')}</span>
          </Link>
        </li>

        <li>
          <Link
            to="/profile/favorites"
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
              location.pathname === "/profile/favorites" ? activeLink : ""
            }`}
          >
            <IoHeart className=" text-2xl" />
            <span className="hidden md:block ml-2">{t('sideBar', 'fav')}</span>
          </Link>
        </li>

        <li>
          <Link
            to="/profile/orders"
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
              location.pathname === "/profile/orders" ? activeLink : ""
            }`}
          >
            <VscHistory className=" text-2xl" />
            <span className="hidden md:block ml-2">{t('sideBar', 'orders')}</span>
          </Link>
        </li>

        <li>
          <Link
            to="/profile/special"
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
              location.pathname === "/profile/special" ? activeLink : ""
            }`}
          >
            <PiMedalFill className=" text-2xl" />
            <span className="hidden md:block ml-2">{t('sideBar', 'contracts')}</span>
          </Link>
        </li>

        <li>
          <Link
            to="/profile/settings"
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start ${
              location.pathname === "/profile/settings" ? activeLink : ""
            }`}
          >
            <IoIosSettings className=" text-2xl" />
            <span className="hidden md:block ml-2">{t('sideBar', 'settings')}</span>
          </Link>
        </li>

        <li>
          <div
            onClick={handleClickLogout}
            className={`flex items-center md:p-4 py-2 md:py-4 justify-center md:justify-start cursor-pointer ${
              location.pathname === "/logout" ? activeLink : ""
            }`}
          >
            <BiLogOutCircle className=" text-2xl" />
            <span className="hidden md:block ml-2">{t('sideBar', 'exit')}</span>
          </div>
        </li>
      </ul>

      {logoutModal && (
        <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50 z-50">
          {/* Modal Container */}
          <div className="bg-white w-11/12 max-w-md rounded-lg shadow-lg p-6 relative">
            {/* Close Button */}
            <button
              onClick={() => setLogoutModal(false)}
              className="absolute top-3 right-3 text-gray-400 hover:text-gray-600"
            >
              ✕
            </button>
            {/* Modal Content */}
            <h2 className="text-xl font-semibold text-center text-gray-800">
            {t('sideBar', 'logout')}
            </h2>
            <div className="mt-6 flex justify-between items-center">
              <button
                onClick={logOutConfirm}
                className="bg-primary-color text-white px-6 py-2 rounded-lg hover:bg-gray-400 transition duration-200"
              >
                   {t('sideBar', 'yes')}
              </button>
              <button
                onClick={() => setLogoutModal(false)}
                className="bg-yellow-color text-gray-700 px-6 py-2 rounded-lg hover:bg-gray-400 transition duration-200"
              >
                   {t('sideBar', 'no')}
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default Sidebar;
